{
  "addFleet": "Añadir flota",
  "table": {
    "empty": "No se ha encontrado ninguna flota",
    "column": {
      "fleet": "Flota",
      "devices": "Equipos",
      "createdAt": "Creación:",
      "updatedAt": "Actualización:",
      "incompatibleDevices": "Equipos incompatibles",
      "information": {
        "incompatibleDevices": "Algunos equipos de la flota no son compatibles con los parámetros actuales.",
        "fleetHasChanged": "Se ha modificado el alcance de la flota.",
        "noDeviceCompatible": "Ningún equipo de esta flota es compatible con la configuración actual de la campaña."
      }
    }
  },
  "addDevices": "Añadir equipos",
  "form": {
    "createFleet": {
      "header": "Crear una flota nueva",
      "validate": "Crear flota",
      "cancel": {
        "confirmMessage": "¿Seguro que desea cancelar la creación de la flota?"
      }
    },
    "validation": {
      "name": "El nombre es obligatorio.",
      "uniqueName": "El nombre de la flota debe ser único"
    },
    "header": {
      "addDevices": "Añadir equipos seleccionados a una flota",
      "createFleet": "Crear una flota"
    },
    "newFleet": "Flota nueva",
    "name": "Nombre de la flota",
    "saveSuccess": "La flota {fleetName} se ha creado correctamente."
  },
  "attachDevices": {
    "updateSuccess": "No se ha añadido ningún equipo. | El equipo se ha añadido correctamente a la flota {fleetName}. | Los equipos se han añadido correctamente a la flota {fleetName}.",
    "title": "Añadir equipos a la flota",
    "confirmMessage": "¿Seguro que desea cancelar la operación? La selección se perderá."
  },
  "removeDevices": {
    "confirmMessage": "¿Seguro que desea eliminar este equipo de la flota? | ¿Seguro que desea eliminar este equipo de la flota? | ¿Seguro que desea eliminar estos equipos de la flota?",
    "confirmTitle": "Eliminar de la flota"
  },
  "actionForbidden": "No tiene el permiso necesario para realizar esta acción.",
  "delete": {
    "title": "Eliminar la flota",
    "confirm": {
      "message": "¿Seguro que desea eliminar la flota seleccionada?"
    }
  },
  "quickActions": {
    "selectedFleets": "No se ha seleccionado ninguna flota. | {count} flota seleccionada | {count} flotas seleccionadas",
    "delete": {
      "title": "No hay flotas para eliminar | Eliminar una flota | Eliminar flotas"
    }
  },
  "bulkDelete": {
    "confirm": {
      "title": "No hay flotas para eliminar | Eliminar flota | Eliminar flotas",
      "message": "No hay flotas para eliminar | ¿Seguro que desea eliminar la flota seleccionada? | ¿Seguro que desea eliminar las flotas seleccionadas?"
    }
  }
}
